import { Injectable } from '@angular/core';
import { Appsettings } from '../../configuration/appsettings';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../security/http.service';
import { Headers, URLSearchParams } from '@angular/http';

// Modelo
import { Coupon } from '../../models/coupon/coupon';

@Injectable({
  providedIn: 'root'
})
export class CouponService {


  constructor(private http: HttpClient, private httpService: HttpService) { }


  // OBTENER CODIGO CONSECUTIVO PARA CANJEAR CUPON
  getCodeCoupon () {

    const API_URL = `${Appsettings.API_ENDPOINT_FULL}/coupons`;
    return this.httpService.get( API_URL );

  }


  getAllCoupon() {
    const API_URL = `${Appsettings.API_ENDPOINT_FULL}/coupons`;

    return this.httpService.get( API_URL )
                           .map( res => res.json());
  }

  getAllByid(){
    const API_URL = `${Appsettings.API_ENDPOINT_FULL}/coupons/getAllById`;

    return this.httpService.get( API_URL )
                           .map( res => res.json());
  }

  getCode(code: string){
    const API_URL = `${Appsettings.API_ENDPOINT_FULL}/users/getcode/?code=${code}`;

    return this.httpService.get( API_URL )
                           .map( res => res.json());
  }



  // CANJEAR CUPON
  exchange( coupon: Coupon ) {

    const API_URL = `${Appsettings.API_ENDPOINT_FULL}/coupons`;
    const HEADERS = new Headers();
    HEADERS.append('Content-Type', 'application/json');

    return this.httpService.post(API_URL, JSON.stringify( coupon ) );

  }

  addCoupon( coupon: Coupon){
    const API_URL = `${Appsettings.API_ENDPOINT_FULL}/coupons`;
    const HEADERS = new Headers();

    HEADERS.append('Content-Type', 'application/json');

    return this.httpService.post(API_URL, JSON.stringify( coupon ), { headers: HEADERS } )
                           .map( res => res.json());
  }



  updateAmount(amunt: number){
    const API_URL = `${Appsettings.API_ENDPOINT_FULL}/users/UpdateAmount`;
    const HEADERS = new Headers();

    HEADERS.append('Content-Type', 'application/json');

    const body = {
      amount: amunt,
      id: 0
    };
    return this.httpService.post(API_URL, JSON.stringify( body ), { headers: HEADERS } )
                           .map( res => res.json());
  }



}
